export default __webpack_public_path__ + "static/media/tiktok.dbcae94e.svg";